import { useMutation } from '@tanstack/react-query';
import { UpdateUserDataRequestTypes } from '../_types/updateUserDataRequest.types';
import { apiUserAccount } from '../../../services/api/ApiService';
import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

interface RegisterUserResponse {
  participantId: string;
}

export const useRegisterUser = () => {
  const schemaId = getSchemaIdFromStorage();
  
  const {
    mutate: registerUser,
    isLoading,
    error,
    isError
  } = useMutation({
    mutationFn: async (data: UpdateUserDataRequestTypes & { captchaToken?: string }): Promise<RegisterUserResponse> => {
      try {
        const headers: Record<string, string> = {};
        if (data.captchaToken) {
          headers['X-Challenge-Verify'] = data.captchaToken;
          headers['X-Challenge-Host'] = process.env.REACT_APP_TURNSTILE_HOST || '';
        }
        
        // Remover captchaToken do body antes de enviar
        const { captchaToken, ...requestData } = data;
        
        return await apiUserAccount.post<RegisterUserResponse>(
          `${ApiEndpoints.account.register}?schemaId=${schemaId}`,
          requestData,
          Object.keys(headers).length > 0 ? { headers } : undefined
        );
      } catch (error) {
        throw error;
      }
    }
  });
  
  return {
    registerUser,
    isRegistering: isLoading,
    registerError: error,
    hasRegisterError: isError
  };
};
